import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, vShow as _vShow, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-426ff412"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-toolbar pb-3 pb-lg-6" }
const _hoisted_2 = { class: "app-container d-flex flex-stack" }
const _hoisted_3 = { class: "page-title d-flex flex-column justify-content-center flex-wrap me-3" }
const _hoisted_4 = {
  key: 0,
  class: "page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0"
}
const _hoisted_5 = {
  key: 1,
  class: "breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<li class=\"breadcrumb-item text-muted\" data-v-426ff412><a class=\"text-muted text-hover-primary\" href=\"/metronic8/demo1/index.html\" data-v-426ff412> Home </a></li><li class=\"breadcrumb-item\" data-v-426ff412><span class=\"bullet bg-gray-500 w-5px h-2px\" data-v-426ff412></span></li><li class=\"breadcrumb-item text-muted\" data-v-426ff412>Account</li>", 3)
const _hoisted_9 = [
  _hoisted_6
]
const _hoisted_10 = { class: "d-flex gap-4" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "indicator-label" }
const _hoisted_15 = { class: "indicator-progress" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_17 = { class: "app-content flex-column-fluid" }
const _hoisted_18 = { class: "app-container" }
const _hoisted_19 = { class: "card mb-5 mb-xl-10" }
const _hoisted_20 = { class: "card-body p-9" }
const _hoisted_21 = { class: "fs-1 fw-bold me-1" }
const _hoisted_22 = { class: "d-flex flex-wrap gap-7 fw-semibold fs-6 mt-2" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "svg-icon svg-icon-2" }
const _hoisted_25 = { class: "text-gray-400 ms-1" }
const _hoisted_26 = { class: "card mb-5 mb-xl-10" }
const _hoisted_27 = { class: "card-header" }
const _hoisted_28 = { class: "card-title m-0" }
const _hoisted_29 = { class: "card-body p-9" }
const _hoisted_30 = {
  class: "mb-10",
  style: {"max-width":"1032px"}
}
const _hoisted_31 = { class: "mb-4 fw-bolder required" }
const _hoisted_32 = { class: "grid grid-cols-2 mw:sm:grid-cols-1 gap-7" }
const _hoisted_33 = { class: "d-flex gap-6" }
const _hoisted_34 = { class: "d-flex" }
const _hoisted_35 = ["value", "disabled"]
const _hoisted_36 = { class: "lh-1 flex-1" }
const _hoisted_37 = { class: "form-check-label fw-bolder mb-3" }
const _hoisted_38 = { class: "mt-0 mb-3" }
const _hoisted_39 = { class: "text-muted" }
const _hoisted_40 = { class: "text-muted float-end" }
const _hoisted_41 = { class: "card mb-5 mb-xl-10" }
const _hoisted_42 = { class: "card-header" }
const _hoisted_43 = { class: "card-title m-0" }
const _hoisted_44 = { class: "card-body p-9" }
const _hoisted_45 = { style: {"max-width":"768px"} }
const _hoisted_46 = { class: "mb-4 fw-bolder required" }
const _hoisted_47 = { class: "table align-middle mb-0" }
const _hoisted_48 = { class: "d-flex gap-7 ps-0" }
const _hoisted_49 = { class: "cursor-pointer form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_50 = { class: "d-flex gap-2" }
const _hoisted_51 = { class: "d-flex" }
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "lh-1 flex-1 d-flex align-items-center" }
const _hoisted_54 = { class: "mb-4 fw-bolder required" }
const _hoisted_55 = { class: "card mb-5 mb-xl-10" }
const _hoisted_56 = { class: "card-header" }
const _hoisted_57 = { class: "card-title m-0" }
const _hoisted_58 = { class: "card-body" }
const _hoisted_59 = { class: "d-flex flex-column gap-10" }
const _hoisted_60 = { class: "form-label required" }
const _hoisted_61 = {
  class: "row row-cols-1 row-cols-xl-3 row-cols-md-2 border border-dashed border-gray-300 rounded pt-3 pb-1 px-2 mb-5 overflow-scroll",
  style: {"max-height":"208px"}
}
const _hoisted_62 = {
  key: 0,
  class: "w-100 text-muted"
}
const _hoisted_63 = {
  key: 0,
  class: "col my-2"
}
const _hoisted_64 = { class: "d-flex border border-dashed border-gray-300 rounded p-3 bg-body" }
const _hoisted_65 = { class: "ms-5 lh-1" }
const _hoisted_66 = { class: "max-sm-text-nowrap mb-2" }
const _hoisted_67 = { class: "text-muted fs-7 mb-4" }
const _hoisted_68 = { class: "text-muted fs-7 mb-2" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" GUID: ")
const _hoisted_70 = { class: "text-muted fs-7 mb-0" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" SKU: ")
const _hoisted_72 = { class: "fw-bold fs-4" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_74 = { class: "d-flex align-items-center position-relative mb-n7" }
const _hoisted_75 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_76 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_77 = ["placeholder"]
const _hoisted_78 = {
  id: "kt_ecommerce_edit_order_product_table_wrapper",
  class: "dt-container dt-bootstrap5 dt-empty-footer"
}
const _hoisted_79 = {
  id: "",
  class: "table-responsive"
}
const _hoisted_80 = { class: "dt-scroll" }
const _hoisted_81 = {
  class: "dt-scroll-head",
  style: {"overflow":"hidden","position":"relative","border":"0px","width":"100%"}
}
const _hoisted_82 = { class: "dt-scroll-headInner w-100 ps-0" }
const _hoisted_83 = { class: "table align-middle table-row-dashed fs-6 gy-5 dataTable ms-0" }
const _hoisted_84 = { class: "text-start text-gray-500 fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_85 = { class: "ps-0" }
const _hoisted_86 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_87 = ["checked"]
const _hoisted_88 = {
  class: "dt-scroll-body",
  style: {"position":"relative","overflow":"auto","max-height":"400px"}
}
const _hoisted_89 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_90 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_91 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_BatchRefundModal = _resolveComponent("BatchRefundModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (0)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, " Account Overview "))
            : _createCommentVNode("", true),
          (0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            disabled: _ctx.loading,
            class: "btn btn-secondary align-self-center text-gray-600",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.backToList")), 1)
          ], 8, _hoisted_11),
          _createElementVNode("button", {
            ref: "applyButton",
            disabled: _ctx.loading,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args))),
            class: "btn btn-primary align-self-center",
            type: "button"
          }, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t("common.submit")), 1),
            _createElementVNode("span", _hoisted_15, [
              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
              _hoisted_16
            ])
          ], 8, _hoisted_13)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.orderInfo.order_number), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, [
                      _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/id.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_25, "SUB#" + _toDisplayString(_ctx.orderInfo.position) + " of " + _toDisplayString(_ctx.orderInfo.total_item_count), 1)
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRefund.relatedDocuments")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("h6", _hoisted_31, _toDisplayString(_ctx.t("orderRefund.selectRelatedDocuments")), 1),
                  _createVNode(_component_el_form_item, { prop: "payment_document" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentDocumentList, (item, index) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: item.pay_order_no,
                            class: _normalizeClass(["border border-dashed rounded-4 px-7 py-5 cursor-pointer", [
                      _ctx.formData.payment_document === item.pay_order_no &&
                        'border-primary bg-light-primary',
                      _ctx.formData.payment_document != item.pay_order_no &&
                        'border-gray-300',
                      _ctx.isZeroAmountPaymentDocument(item) &&
                        'border-gray-300 bg-gray-100 disabled',
                    ]])
                          }, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.payment_document) = $event)),
                                  type: "radio",
                                  name: "payment_document_radio",
                                  value: item.pay_order_no,
                                  disabled: 
                            _ctx.justOnePaymentDocument ||
                            _ctx.isZeroAmountPaymentDocument(item)
                          
                                }, null, 8, _hoisted_35), [
                                  [_vModelRadio, _ctx.formData.payment_document]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("h3", _hoisted_37, _toDisplayString(_ctx.t("orderRefund.document")) + " " + _toDisplayString(index + 1), 1),
                                _createElementVNode("p", _hoisted_38, "No.: " + _toDisplayString(item.pay_order_no), 1),
                                _createElementVNode("span", _hoisted_39, _toDisplayString(item.currency == "CNY"
                            ? _ctx.$currency.currency(item.amount, 2, ".", "", "￥ ")
                            : _ctx.$currency.currency(item.amount, 2, ",", ".", "€ ")), 1),
                                _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.formatDate(item.pay_date)), 1)
                              ])
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRefund.refundInformation")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("h6", _hoisted_46, _toDisplayString(_ctx.t("orderRefund.refundReason")), 1),
                  _createVNode(_component_el_form_item, {
                    prop: "refund_reason",
                    class: "mb-8"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_47, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedRefundReasonList, (group, groupIndex) => {
                          return (_openBlock(), _createElementBlock("tr", { key: groupIndex }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: item.value
                              }, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("label", _hoisted_49, [
                                    _createElementVNode("div", _hoisted_50, [
                                      _createElementVNode("div", _hoisted_51, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "form-check-input",
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.refund_reason) = $event)),
                                          type: "radio",
                                          name: "refund_reason_radio",
                                          value: item.value
                                        }, null, 8, _hoisted_52), [
                                          [_vModelRadio, _ctx.formData.refund_reason]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_53, [
                                        _createElementVNode("span", null, _toDisplayString(item.label), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.formData.refund_reason === 'other')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        prop: "refund_reason_note",
                        class: "mb-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("h6", _hoisted_54, _toDisplayString(_ctx.t("orderRefund.note")), 1),
                          _createVNode(_component_el_input, {
                            class: "mw-600px",
                            modelValue: _ctx.formData.refund_reason_note,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.refund_reason_note) = $event)),
                            type: "textarea",
                            placeholder: _ctx.t('common.plsEnter'),
                            clearable: "",
                            maxlength: "100",
                            "show-word-limit": "",
                            resize: "none"
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.t("orderRefund.selectProducts")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.t("orderRefund.selectProductsTip")), 1),
                    _createVNode(_component_el_form_item, {
                      prop: "selected_products",
                      class: "mb-8"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_61, [
                          (_ctx.formData.selected_products.length == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.t("orderRefund.selectProductsOperationTip")), 1))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productListBackup, (item) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: item.guid
                            }, [
                              (_ctx.thisItemIsSelected(item))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                    _createElementVNode("div", _hoisted_64, [
                                      _createVNode(_component_product_info, {
                                        class: "w-40px d-inline-block align-middle mx-2 product-info-small",
                                        gallery: [
                              { id: item.guid, origin_url: item.image },
                            ]
                                      }, null, 8, ["gallery"]),
                                      _createElementVNode("div", _hoisted_65, [
                                        _createElementVNode("p", _hoisted_66, _toDisplayString(item.brand), 1),
                                        _createElementVNode("p", _hoisted_67, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.getName(item)), 1)
                                        ]),
                                        _createElementVNode("p", _hoisted_68, [
                                          _hoisted_69,
                                          _createElementVNode("span", null, _toDisplayString(item.guid), 1)
                                        ]),
                                        _createElementVNode("p", _hoisted_70, [
                                          _hoisted_71,
                                          _createElementVNode("span", null, _toDisplayString(item.brand_article_no
                                  ? item.brand_article_no
                                  : item.merchant_article_no), 1)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.t("orderRefund.totalRefund")) + " : " + _toDisplayString(_ctx.$currency.currency(_ctx.totalRefundComputed, 2, ",", ".", "€ ")), 1)
                  ]),
                  _hoisted_73,
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("span", _hoisted_76, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event)),
                        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchItems())),
                        class: "form-control form-control-solid w-400px ps-14",
                        placeholder: _ctx.t('common.search')
                      }, null, 40, _hoisted_77), [
                        [_vModelText, _ctx.search]
                      ]),
                      _withDirectives(_createElementVNode("span", {
                        class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle cursor-pointer",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
                      }, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ], 512), [
                        [_vShow, _ctx.search != '']
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("table", _hoisted_83, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", _hoisted_84, [
                                  _createElementVNode("th", _hoisted_85, [
                                    _createElementVNode("div", _hoisted_86, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectAll) = $event)),
                                        checked: _ctx.selectAll,
                                        type: "checkbox",
                                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleSelectAll && _ctx.handleSelectAll(...args)))
                                      }, null, 8, _hoisted_87), [
                                        [_vModelCheckbox, _ctx.selectAll]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("th", null, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRefund.product.productName")), 1)
                                  ]),
                                  _createElementVNode("th", null, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRefund.product.sku")), 1)
                                  ]),
                                  _createElementVNode("th", null, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRefund.product.guid")), 1)
                                  ]),
                                  _createElementVNode("th", null, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRefund.product.status")), 1)
                                  ]),
                                  _createElementVNode("th", null, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRefund.product.unit")), 1)
                                  ]),
                                  _createElementVNode("th", null, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.t("orderRefund.product.total")), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("colgroup", null, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (n) => {
                                  return _createElementVNode("col", {
                                    key: n,
                                    style: _normalizeStyle({ width: _ctx.getColumnWidth(n - 1) })
                                  }, null, 4)
                                }), 64))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("table", _hoisted_89, [
                            _createElementVNode("colgroup", null, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (n) => {
                                return _createElementVNode("col", {
                                  key: n,
                                  style: _normalizeStyle({ width: _ctx.getColumnWidth(n - 1) })
                                }, null, 4)
                              }), 64))
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: item.guid
                                }, [
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_90, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.selected_products) = $event)),
                                        class: "form-check-input",
                                        type: "checkbox",
                                        value: item.guid,
                                        onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.resetSelectAll && _ctx.resetSelectAll(...args)))
                                      }, null, 40, _hoisted_91), [
                                        [_vModelCheckbox, _ctx.formData.selected_products]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_product_info, {
                                      gallery: [
                                  { id: item.guid, origin_url: item.image },
                                ],
                                      name: item.name,
                                      name_en: item.name_en,
                                      brand_id: item.brand
                                    }, null, 8, ["gallery", "name", "name_en", "brand_id"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_sku_info, {
                                      brand_article_no: 
                                  item.brand_article_no
                                    ? item.brand_article_no
                                    : item.merchant_article_no
                                ,
                                      color: item.original_color,
                                      size: item.size,
                                      product_identifier_id: '0'
                                    }, null, 8, ["brand_article_no", "color", "size"])
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(item.guid), 1),
                                  _createElementVNode("td", null, _toDisplayString(item.stage.node), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$currency.currency(
                                  item.unit_price,
                                  2,
                                  ",",
                                  ".",
                                  "€ "
                                )), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.$currency.currency(
                                  item.total,
                                  2,
                                  ",",
                                  ".",
                                  "€ "
                                )), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _createVNode(_component_BatchRefundModal, {
        ref: "orderRoutingBatchRefundModalRef",
        product: _ctx.batchRefundProduct,
        onBatchRefundSubmit: _ctx.handleBatchRefundSubmit
      }, null, 8, ["product", "onBatchRefundSubmit"])
    ])
  ], 64))
}